/**
 * src/actions/notification-same-setting-store.js
 * localStorageに対し、メンバー招待ダイアログ（トライアル中表示）の表示／非表示を格納、取得、クリア
 */

import PermanentStore from './permanent-store'

const KEY = "gambaApp.notification-all-setting"
export default PermanentStore(KEY)




// WEBPACK FOOTER //
// ./src/actions/notification-all-setting-store.js